export default __webpack_public_path__ + "static/media/icon-horaire.fde4d011.svg";